export function newsTitle(article: any): string {
    const title = article && article.title ? article.title : 'Berita Produsen Baja Ringan';
    return title.replace(/_/g, ' ');
}

export function newsPath(article: any): string {
    const identifier = article && (article.slug || article.title);
    return `/news/detail/${encodeURIComponent(identifier || '')}`;
}

// A public Instagram permalink we are allowed to embed (post, reel or IGTV).
export function isPublicInstagramUrl(value: any): value is string {
    try {
        const url = new URL(value);
        const host = url.hostname.replace(/^www\./, '');
        return host === 'instagram.com'
            && /(?:^|\/)(?:p|reel|tv)\/[A-Za-z0-9._-]+\/?$/.test(url.pathname);
    } catch (ex) {
        return false;
    }
}

// An Instagram-sourced article renders its video embed instead of local images.
export function isInstagramArticle(article: any): boolean {
    return !!(article && isPublicInstagramUrl(article.instagramUrl));
}

// Canonical preview image. For Instagram articles this is the video cover frame,
// resolved server-side from the instagramUrl, so the old local image is never used.
export function newsThumbnail(article: any): string {
    if (isInstagramArticle(article)) {
        const identifier = article.slug || article.title;
        if (identifier) {
            return `${process.env.REACT_APP_HOST_NAME}/news/thumbnail/${encodeURIComponent(identifier)}`;
        }
    }
    return article && article.image ? article.image : '';
}

export function bodyText(article: any): string {
    if (!article || !Array.isArray(article.body)) {
        return '';
    }
    return article.body.filter((block: any) => typeof block === 'string').join('\n\n');
}

export function newsExcerpt(article: any, length: number): string {
    const source = (article && article.text)
        || bodyText(article)
        || (article && article.metaDescription)
        || (article && article.desc ? String(article.desc).replace(/_/g, ' ') : '')
        || '';
    const normalized = source.replace(/\s+/g, ' ').trim();
    return normalized.length > length ? `${normalized.substring(0, length - 3)}...` : normalized;
}
